import React, { useEffect } from 'react';
import { PMHero } from '../sections/pm/PMHero';
import { Process } from '../sections/Process';
import { DayOneToPlan } from '../sections/DayOneToPlan';
import { Benefits } from '../sections/Benefits';
import { Services } from '../sections/Services';
import { TeamCarousel } from '../sections/TeamCarousel';
import { NoInterviewBand } from '../sections/NoInterviewBand';
import { Pricing } from '../sections/Pricing';
import { FAQ } from '../sections/FAQ';
import { MobileCTABar } from '../MobileCTABar';
export const FractionalPM = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main data-id="element-130">
      <PMHero data-id="element-131" />
      <Process data-id="element-132" />
      <DayOneToPlan data-id="element-133" />
      <Benefits data-id="element-134" />
      <Services data-id="element-135" />
      <TeamCarousel data-id="element-136" />
      <NoInterviewBand data-id="element-137" />
      <Pricing data-id="element-138" />
      <FAQ data-id="element-139" />
      <MobileCTABar data-id="element-140" />
    </main>;
};